// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"5384886950e80d9f3274","655":"6bba7b4a45f4c79cb214"}[chunkId] + ".js";
};